export type Clock = { now(): number; sleep(ms: number): Promise<void> };

export const realClock: Clock = {
  now: () => Date.now(),
  sleep: (ms) => new Promise((r) => setTimeout(r, ms)),
};

/** Serialises callers so successive starts are at least `minIntervalMs` apart. */
export class RateLimiter {
  private next = 0;
  private chain: Promise<void> = Promise.resolve();

  constructor(
    readonly minIntervalMs: number,
    private readonly clock: Clock = realClock,
  ) {}

  /** Resolves when the caller may start its request. */
  wait(): Promise<void> {
    const turn = this.chain.then(async () => {
      const now = this.clock.now();
      if (now < this.next) await this.clock.sleep(this.next - now);
      this.next = Math.max(now, this.next) + this.minIntervalMs;
    });
    this.chain = turn.catch(() => undefined);
    return turn;
  }
}

/** One limiter per host, shared across the worker. */
const limiters = new Map<string, RateLimiter>();
export function limiterFor(host: string, minIntervalMs: number): RateLimiter {
  let l = limiters.get(host);
  if (!l) {
    l = new RateLimiter(minIntervalMs);
    limiters.set(host, l);
  }
  return l;
}
